import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class DpiaAssessmentApi extends BaseApi {
    constructor(client) {
        super(client, '/dpia-assessment');
    }

    async submit(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/submit`, {});
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async complete(id, data) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/complete`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async createRisk(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/create-risk`, {});
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
